export const _setDrug1UsedId = (state, action) => {
  state.drug1UsedId = action.payload;
};

export const _setIsProfA2DataLoaded = (state, action) => {
  state.isProfA2DataLoaded = action.payload;
};

export const _setDrug2UsedId = (state, action) => {
  state.drug2UsedId = action.payload;
};

export const _setDrug3UsedId = (state, action) => {
  state.drug3UsedId = action.payload;
};

export const _setDrug4UsedId = (state, action) => {
  state.drug4UsedId = action.payload;
};

export const _setDrug1InTakeId = (state, action) => {
  state.drug1InTakeId = action.payload;
};

export const _setDrug2InTakeId = (state, action) => {
  state.drug2InTakeId = action.payload;
};

export const _setDrug3InTakeId = (state, action) => {
  state.drug3InTakeId = action.payload;
};

export const _setDrug4InTakeId = (state, action) => {
  state.drug4InTakeId = action.payload;
};

export const _setDrug1FrequencyId = (state, action) => {
  state.drug1FrequencyId = action.payload;
};

export const _setDrug2FrequencyId = (state, action) => {
  state.drug2FrequencyId = action.payload;
};

export const _setDrug3FrequencyId = (state, action) => {
  state.drug3FrequencyId = action.payload;
};

export const _setDrug4FrequencyId = (state, action) => {
  state.drug4FrequencyId = action.payload;
};

export const _setDrug1AgeFirstUsed = (state, action) => {
  state.drug1AgeFirstUsed = action.payload;
};

export const _setDrug2AgeFirstUsed = (state, action) => {
  state.drug2AgeFirstUsed = action.payload;
};

export const _setDrug3AgeFirstUsed = (state, action) => {
  state.drug3AgeFirstUsed = action.payload;
};

export const _setDrug4AgeFirstUsed = (state, action) => {
  state.drug4AgeFirstUsed = action.payload;
};

export const _setLengthofTimeSinceClientLastUsed = (state, action) => {
  state.LengthofTimeSinceClientLastUsed = action.payload;
};

export const _setTimeSpentinInstitutions = (state, action) => {
  state.TimeSpentinInstitutions = action.payload;
};

export const _setProgram1Name = (state, action) => {
  state.program1Name = action.payload;
};

export const _setProgram2Name = (state, action) => {
  state.program2Name = action.payload;
};

export const _setProgram3Name = (state, action) => {
  state.program3Name = action.payload;
};

export const _setProgram1Modality = (state, action) => {
  state.program1Modality = action.payload;
};

export const _setProgram2Modality = (state, action) => {
  state.program2Modality = action.payload;
};

export const _setProgram3Modality = (state, action) => {
  state.program3Modality = action.payload;
};

export const _setProgram1Year = (state, action) => {
  state.program1Year = action.payload;
};

export const _setProgram2Year = (state, action) => {
  state.program2Year = action.payload;
};

export const _setProgram3Year = (state, action) => {
  state.program3Year = action.payload;
};

export const _setProgram1Completed = (state, action) => {
  state.program1Completed = action.payload;
};

export const _setProgram2Completed = (state, action) => {
  state.program2Completed = action.payload;
};

export const _setProgram3Completed = (state, action) => {
  state.program3Completed = action.payload;
};

export const _setProgram1TreatmentLength = (state, action) => {
  state.program1TreatmentLength = action.payload;
};

export const _setProgram2TreatmentLength = (state, action) => {
  state.program2TreatmentLength = action.payload;
};

export const _setProgram3TreatmentLength = (state, action) => {
  state.program3TreatmentLength = action.payload;
};

export const _setTreatmentAccomplishments = (state, action) => {
  state.treatmentAccomplishments = action.payload;
};

export const _setReferredForTreatment = (state, action) => {
  state.referredForTreatment = action.payload;
};

export const _setNotReferredInappropriate = (state, action) => {
  state.notReferredInappropriate = action.payload;
};

export const _setNotReferredRefusingTreatment = (state, action) => {
  state.notReferredRefusingTreatment = action.payload;
};

export const _setResidential = (state, action) => {
  state.residential = action.payload;
};

export const _setSoberLiving = (state, action) => {
  state.soberLiving = action.payload;
};

export const _setOutPatient = (state, action) => {
  state.outPatient = action.payload;
};

export const _setDayTreatment = (state, action) => {
  state.dayTreatment = action.payload;
};

export const _setRecommendResidentialWithChild = (state, action) => {
  state.recommendResidentialWithChild = action.payload;
};

export const _setRecommendSoberLivingWithChild = (state, action) => {
  state.recommendSoberLivingWithChild = action.payload;
};

export const _setRecommendSoberLivingWithIntensiveOdf = (state, action) => {
  state.recommendSoberLivingWithIntensiveOdf = action.payload;
};

export const _setFOTEP = (state, action) => {
  state.FOTEP = action.payload;
};

export const _setCommentOnRecommendations = (state, action) => {
  state.commentOnRecommendations = action.payload;
};

export const _setProgramTransitionalStaffId = (state, action) => {
  state.programTransitionalStaffId = action.payload;
};

export const _setDateSigned = (state, action) => {
  state.dateSigned = action.payload;
};
